export const rootUrl = "https://classes-stg.texaswic.org";
export const apiUrl = "https://classes-stg.texaswic.org/api";
export const cookieDomain = "classes-stg.texaswic.org";
export const drupalSiteUrl = "http://stg.texaswic.org";
export const lrsUrl = "https://lrs-stg.texaswic.org/storyline-test/xapi/";
export const lrsAuth = "Basic aG9hc2l6OnViYm9rdQ==";
export const anonymousEmail = "anonymous@texaswic.org";
export const sentryEnvironment = "staging";




// WEBPACK FOOTER //
// ./src/config.js